import IsLocalHost from './isLocalHost'
export default IsLocalHost
